import React, { useContext, useEffect, useState } from 'react';
import { Images } from '../../data/Images';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { themeContext } from '../../Context/ThemeContext';
import ThemeImg, { ImageComponent } from './ThemeImg';
import { Dropdown, DropdownButton } from 'react-bootstrap';
import Walletbutton from "../../components/walletbutton";
import { HiOutlineMenu } from "react-icons/hi";
import { CgClose } from "react-icons/cg";

export default function Header() {
    const { themeValue, handleThemeChange } = useContext(themeContext);
    const [scrolled, setScrolled] = useState(false);
    const [menuToggle, setMenuToggle] = useState(false);
    const [currentPath, setCurrentPath] = useState("");
    const { pathname } = useLocation();
    useEffect(() => {

        const handleScroll = () => {
            if (window.scrollY > 0) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    useEffect(() => {
        if (pathname) {
            const path = pathname.split("/").filter((item) => item !== "")[0];
            setCurrentPath(path);
        }
    }, [pathname])
    return (
        <div className={`pageHeaderPart ${scrolled ? "scrolled" : ""}`}>
            <div className={`headerInnerPart ${menuToggle ? "isActive" : ""}`}>
                <div className="headerLogoPart d-flex align-items-center">
                    <div className='logoPart'>
                        <Link to={"/"}>
                            {
                                currentPath !== "launchpad" ?
                                    <ImageComponent themeImgSrc={"footerNexusLogo"} />
                                    :
                                    <ImageComponent staticImgSrc={"dark_footerNexusLogo"} />
                            }
                        </Link>
                    </div>
                    <div className="listPart">
                        <ul>
                            <li>
                                <NavLink to={`/launchpad/${localStorage.getItem("saleaddress")}`}>launchpad</NavLink>
                            </li>
                            <li>
                                <NavLink to={`/works`}>How it Works</NavLink>
                            </li>
                            <li>
                                <NavLink to={`/apply-list`}>Apply to List</NavLink>
                            </li>
                            <li>
                                <NavLink to={`/nexus-token`}>Nexus Token</NavLink>
                            </li>
                            <li>
                                <NavLink to={`/dao`}>DAO</NavLink>
                            </li>
                            <li>
                                <NavLink to={`/ai`}>AI</NavLink>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className='d-flex gap-2 align-items-center'>
                    <Walletbutton />
                    <button className='themeBtn' onClick={handleThemeChange}>
                        <img src={themeValue ? Images.moonIcon : Images.sunIcon} alt="theme icon" />
                    </button>
                </div>
                <div className='menuContainer'>
                    <button onClick={() => setMenuToggle(!menuToggle)} className='menuCloseBtn'>
                        {
                            menuToggle ?
                                <CgClose /> :
                                <HiOutlineMenu />
                        }
                    </button>
                </div>
            </div>
        </div>
    );
}
